module.exports = __webpack_public_path__ + "static/arcadium-web-627758ca48709e7296c701aa4ce39410.jpg";